import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ArticleBlock } from '../../../../models/article';

export enum ImageLayoutType {
  layoutFirst = 1,
  layoutSecond = 2,
  layoutThird = 3,
}

@Component({
  selector: 'app-article-image-layout-model',
  templateUrl: './article-image-layout-model.component.html',
  styleUrls: ['./article-image-layout-model.component.scss'],
})
export class ArticleImageLayoutModelComponent implements OnInit {
  @ViewChild('layoutSelect') imageLayoutComponent: TemplateRef<any>;

  @Output() updateLayout = new EventEmitter<ArticleBlock>();

  @Input() selectedLayout = ImageLayoutType.layoutSecond;

  @Input() blockElement: ArticleBlock;

  imageLayoutType = ImageLayoutType;

  private modalService = inject(NgbModal);

  ngOnInit(): void { }

  open() {
    this.modalService.open(this.imageLayoutComponent, {
      windowClass: 'layout-select-modal',
      centered: true,
    });
  }

  onLayoutChange(layout: ImageLayoutType) {
    this.blockElement.layout = layout;
    this.updateLayout.emit(this.blockElement);
    this.modalService.dismissAll('cross click');
  }
}
